
export const sysUrl: string = window['__next_sys_url'] || '../sys'

export const routerBase: string | undefined = window['__next_router_base']
